import { render, staticRenderFns } from "./SolicitudEdicion.vue?vue&type=template&id=031af2f6&scoped=true"
import script from "./SolicitudEdicion.vue?vue&type=script&lang=js"
export * from "./SolicitudEdicion.vue?vue&type=script&lang=js"
import style0 from "./SolicitudEdicion.vue?vue&type=style&index=0&id=031af2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031af2f6",
  null
  
)

export default component.exports